var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',{attrs:{"outlined":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',[_c('apexchart',{attrs:{"type":"bar","width":"500","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }